import * as yup from 'yup'
import { IntlShape } from 'react-intl'

import { capacityLimitsSchema } from '../CapacityLimitsCard/schema'
import { visualizationSettingsSchema } from '../VisualizationSettingsCard/schema'
import { ISettingsForm } from './types'

export const settingsFormSchema = (intl: IntlShape): yup.SchemaOf<ISettingsForm> => {
  return yup.object().shape({
    ...capacityLimitsSchema(intl).fields,
    ...visualizationSettingsSchema(intl).fields
  })
}
